import React, { useState } from "react";
import {
  FaMapMarkerAlt,
  FaClock,
  FaBriefcase,
  FaChevronDown,
  FaChevronUp,
  FaCheckCircle,
} from "react-icons/fa";
import "./JobOpenings.css";

function JobOpenings({ career, setValue }) {
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [expandedJobId, setExpandedJobId] = useState(null);

  const toggleExpandJob = (id) => {
    setExpandedJobId(expandedJobId === id ? null : id);
  };

  return (
    <div className="job-openings-section-wrapper">
      {/* Section Heading */}
      <div className="text-center mb-5">
        <span className="text-overline">Current Openings</span>

        <h2 className="section-title-highlight">We Are Hiring!</h2>

        <p className="section-description">
          Find your fit and help us construct tomorrow's digital solutions.
          Click on any position below to read the role descriptions and
          requirements.
        </p>
      </div>

      {/* Jobs List */}
      <div className="jobs-list-container">
        {career?.length > 0 ? (
          career?.map((job) => {
            const isExpanded = expandedJobId === job.id;

            return (
              <div
                key={job.id}
                className={`job-row-card ${
                  isExpanded ? "is-active-expanded" : ""
                }`}
              >
                {/* Job Header */}
                <div
                  className="job-card-header-clickable"
                  onClick={() => toggleExpandJob(job.id)}
                >
                  <div className="job-main-info">
                    <span className="job-dept-badge">{job.JobType?.name}</span>

                    <h4 className="job-title">{job.name}</h4>

                    <div className="job-meta-tags">
                      <div className="meta-tag">
                        <FaMapMarkerAlt />
                        {job.Country?.name} {job.State?.name} {job.City?.name} (
                        {job.LocationType?.name})
                      </div>

                      <div className="meta-tag">
                        <FaClock />
                        {job.TimeType?.name}
                      </div>

                      <div className="meta-tag">
                        <FaBriefcase />
                        {job.experience}
                      </div>
                    </div>
                  </div>

                  <div className="job-expand-indicator-btn">
                    {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                  </div>
                </div>

                {/* Expandable Content */}
                <div
                  className={`job-collapsible-body-content ${
                    isExpanded ? "show-expanded" : ""
                  }`}
                >
                  <div className="body-inner-padding">
                    <h5>Role Description</h5>

                    <p className="job-long-description">
                      {htmlToReactParser.parse(job.description)}
                    </p>

                    <h5>Key Requirements & Prerequisites</h5>

                    <ul className="requirements-checklist-ul">
                      {job?.CareerKeyRequirements?.map((req, index) => (
                        <li key={index}>
                          <FaCheckCircle className="li-check-bullet" />

                          <span>{req?.KeyRequirement?.name}</span>
                        </li>
                      ))}
                    </ul>

                    {/* Apply Button */}
                    <div className="apply-trigger-footer-row">
                      <button
                        className="job-direct-apply-btn"
                        onClick={() => {
                          setValue(
                            "career_id",
                            {
                              value: job.id,
                              label: job.name,
                              name: "career_id",
                            },
                            {
                              shouldValidate: true,
                              shouldDirty: true,
                            },
                          );

                          const section = document.getElementById(
                            "apply-now-form",
                          );

                          if (section) {
                            section.scrollIntoView({
                              behavior: "smooth",
                              block: "start",
                            });
                          }
                        }}
                      >
                        Apply For This Position
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="no-jobs-alert">
            <p>No active job openings available right now.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default JobOpenings;
